import { useTranslation } from "react-i18next";
import type { ScriptLookupType, TabDef } from "~/types/ui";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "~/components/ui/tabs";
import { TagLookupTable } from "./tag-lookup-table";

export function ScriptLookup({
  options,
}: {
  options?: {
    label: string;
    value: ScriptLookupType[]; // TODO Add other value type to lookup formulas
  }[];
}) {
  const { t } = useTranslation();
  const tabs: TabDef[] = [
    {
      value: "tag-lookup",
      labelKey: "tag",
      content: (
        <TagLookupTable
          options={
            options?.filter((x) => x.label == "tag-lookup")?.at(0)?.value ?? []
          }
        />
      ),
    },
    //  { // To be implemented
    //    value: "formula-lookup",
    //    labelKey: "formula",
    //    content: (
    //   <FormulaLookupTable
    //     options={
    //       options?.filter((x) => x.label == "formula-lookup")?.at(0)?.value ?? []
    //     }
    //   />
    // ),
    //  },
  ];

  return (
    <Tabs
      defaultValue={tabs[0].value}
      className="h-[75vh] bg-card rounded-r overflow-x-hidden"
    >
      <TabsList className="border">
        {tabs.map((tab) => (
          <TabsTrigger key={tab.value} value={tab.value} className="mr-2">
            {t(`scripts.lookupTable.${tab.labelKey}.title`)}
          </TabsTrigger>
        ))}
      </TabsList>

      {tabs.map((tab) => (
        <TabsContent key={tab.value} value={tab.value} className="w-full mt-2">
          {tab.content}
        </TabsContent>
      ))}
    </Tabs>
  );
}
